import { companySystem } from "./company";
import { directorSystem } from "./director";
import { conventionSystem } from "./conventions";
import { goalsSystem } from "./goals";
import { marketSystem } from "./market";
import { boothSystem } from "./booths";
import { decadeSystem } from "./decades";
import { fanMailSystem } from "./fanmail";
import { imprintSystem } from "./imprints";
import type { GameState } from "./state";

/** A system runs once per week, in the fixed order of SYSTEMS. */
export interface WeeklySystem {
  name: string;
  init?(state: GameState): void;
  week(state: GameState): void;
}

// booths run just before the conventions, so a booth's goodwill with the judges counts at that week's awards
export const SYSTEMS: WeeklySystem[] = [marketSystem, companySystem, boothSystem, conventionSystem, goalsSystem, directorSystem, decadeSystem, fanMailSystem, imprintSystem];
